import React from 'react';
import { PlanListingFilterTagsProps } from '../Types/Plans.Type';
import { useDictionary } from 'lib/utils';
import Icon from 'components/helpers/Icon';
import classNames from 'classnames/bind';
import styles from './PlanOptionsListingGraphQL.module.scss';
import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

const PlanListingFilterTags: React.FC<PlanListingFilterTagsProps> = (props) => {
  const cx = classNames.bind(styles);
  const { selectedFilterOptions, removeOptionFromFilter } = props;
  const removeFilterLabel = useDictionary('Remove filter');
  const { sitecoreContext } = useSitecoreContext();

  return (
    <div className={cx('plan-options-listing--filters-tags')}>
      <div>
        {selectedFilterOptions.length > 0 &&
          selectedFilterOptions.map((selectedFilter, selectedFilterIndex) => {
            return (
              <div
                key={`filter-tag-${selectedFilterIndex}`}
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key == 'Enter' || event.key == ' ') {
                    event.preventDefault();
                    removeOptionFromFilter(selectedFilter.id);
                  }
                }}
              >
                <Text field={{ value: selectedFilter.displayName }} encode={sitecoreContext.pageEditing} />
                <button
                  type="button"
                  onClick={() => removeOptionFromFilter(selectedFilter.id)}
                  title={`${removeFilterLabel} ${selectedFilter.displayName}`}
                  className={cx('iconButton')}
                >
                  <span role="img" aria-label="remove filter">
                    <Icon variant="close" className={cx('iconSmall')} />
                  </span>
                </button>
              </div>
            );
          })}
        {selectedFilterOptions.length <= 0 && <div className={cx('noColor')}>&nbsp;</div>}
      </div>
    </div>
  );
};

export default PlanListingFilterTags;
